import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Zap, X, ShoppingCart, ShoppingBag, ArrowDownLeft, ArrowUpRight, Sparkles, } from 'lucide-react';
export function QuickActionsFloating() {
    const { t, i18n } = useTranslation();
    const isRtl = i18n.language === 'ar';
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const actions = [
        {
            id: 'quick-pos',
            label: isRtl ? 'كاشير POS' : 'Fast POS',
            icon: Sparkles,
            color: 'bg-emerald-600 hover:bg-emerald-700 text-white',
            onClick: () => {
                navigate('/pos');
                setIsOpen(false);
            },
        },
        {
            id: 'quick-sale',
            label: isRtl ? 'فاتورة بيع' : 'Sale Bill',
            icon: ShoppingCart,
            color: 'bg-blue-600 hover:bg-blue-700 text-white',
            onClick: () => {
                navigate('/sales');
                setIsOpen(false);
            },
        },
        {
            id: 'quick-purchase',
            label: isRtl ? 'فاتورة شراء' : 'Purchase Bill',
            icon: ShoppingBag,
            color: 'bg-indigo-600 hover:bg-indigo-700 text-white',
            onClick: () => {
                navigate('/purchases');
                setIsOpen(false);
            },
        },
        {
            id: 'quick-collect',
            label: isRtl ? 'سند قبض' : 'Receipt (In)',
            icon: ArrowDownLeft,
            color: 'bg-emerald-600 hover:bg-emerald-700 text-white',
            onClick: () => {
                navigate('/treasury');
                setIsOpen(false);
            },
        },
        {
            id: 'quick-pay',
            label: isRtl ? 'سند صرف' : 'Payment (Out)',
            icon: ArrowUpRight,
            color: 'bg-rose-600 hover:bg-rose-700 text-white',
            onClick: () => {
                navigate('/treasury');
                setIsOpen(false);
            },
        },
    ];
    return (_jsxs("div", { className: "fixed bottom-12 end-6 z-40 flex flex-col items-end gap-2.5", children: [isOpen && (_jsx("div", { className: "flex flex-col items-end gap-2 animate-in fade-in slide-in-from-bottom-5 duration-200", children: actions.map((action) => (_jsxs("button", { type: "button", onClick: action.onClick, className: "flex items-center gap-2.5 px-3.5 py-2 rounded-2xl bg-white text-slate-800 border border-slate-200/90 shadow-lg hover:shadow-xl hover:bg-slate-50 transition-all cursor-pointer group", children: [_jsx("span", { className: "text-xs font-bold text-slate-700 group-hover:text-blue-600 transition-colors", children: action.label }), _jsx("div", { className: `w-8 h-8 rounded-xl flex items-center justify-center shadow-xs ${action.color}`, children: _jsx(action.icon, { className: "w-4 h-4" }) })] }, action.id))) })), _jsx("button", { type: "button", onClick: () => setIsOpen(!isOpen), className: `w-12 h-12 rounded-2xl shadow-xl flex items-center justify-center text-white transition-all cursor-pointer duration-200 active:scale-95 ${isOpen
                    ? 'bg-slate-900 rotate-90 shadow-slate-900/30'
                    : 'bg-blue-600 hover:bg-blue-700 shadow-blue-600/30 hover:scale-105'}`, title: t('workflow.speedDial'), children: isOpen ? _jsx(X, { className: "w-6 h-6" }) : _jsx(Zap, { className: "w-6 h-6 fill-current" }) })] }));
}
//# sourceMappingURL=QuickActionsFloating.js.map